import L from "leaflet";

// Leaflet CSS must be loaded once globally (Vite supports this import).
import "leaflet/dist/leaflet.css";

// Fix default marker icons in bundlers (Leaflet expects assets at runtime).
// Vite will rewrite these imports to hashed URLs in the build output.
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});

